import { Link } from 'react-router-dom';
import { FileQuestion } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface NotFoundProps {
  title?: string;
  description?: string;
}

/**
 * Used by the RequireAdmin route guard so non-admins who navigate to
 * `/admin` see a clean "Page Not Found" instead of the admin
 * scaffolding rendering with a 403 error card inside it. Same shell as
 * EmptyState but standalone — the icon + copy convey "wrong URL", not
 * "no data yet".
 */
export function NotFound({
  title = 'Page Not Found',
  description = "This page doesn't exist or you don't have access.",
}: NotFoundProps = {}) {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full border-2 border-dashed th-border mb-4">
        <FileQuestion className="h-7 w-7 th-text-muted" />
      </div>
      <h3 className="text-lg font-semibold th-text">{title}</h3>
      <p className="mt-1 max-w-sm text-sm th-text-muted">{description}</p>
      <div className="mt-6">
        <Button asChild variant="outline" size="sm">
          <Link to="/">Back to home</Link>
        </Button>
      </div>
    </div>
  );
}
